import { motion } from "framer-motion";

const WindowMock = ({ img, alt, className }) => (
  <div className={`we-window ${className}`}>
    <div className="we-window-bar">
      <span className="we-dot bg-[#ff5f57]" />
      <span className="we-dot bg-[#febc2e]" />
      <span className="we-dot bg-[#28c840]" />
      <span className="ml-3 h-3 w-24 rounded-full bg-white/10" />
    </div>
    <img src={img} alt={alt} loading="lazy" className="h-full w-full object-cover" />
  </div>
);

export const HeroWindows = ({ mx, my, yBack, yFront }) => (
  <>
    <motion.div data-testid="hero-window-design" style={{ y: yBack, x: mx }} className="pointer-events-none absolute left-[6%] top-[22%] w-64 opacity-70">
      <WindowMock img="https://images.unsplash.com/photo-1547658719-da2b51169166?crop=entropy&cs=srgb&fm=jpg&q=80&w=600" alt="Ejemplo de panel de diseño web moderno" className="h-44" />
    </motion.div>
    <motion.div data-testid="hero-window-interface" style={{ y: yFront, x: my }} className="pointer-events-none absolute right-[7%] top-[16%] w-72 opacity-80">
      <WindowMock img="https://images.unsplash.com/photo-1665470909928-a832ebc923d1?crop=entropy&cs=srgb&fm=jpg&q=80&w=600" alt="Interfaz de una página web profesional" className="h-48" />
    </motion.div>
    <motion.div data-testid="hero-window-statistics" style={{ y: yBack, x: my }} className="pointer-events-none absolute bottom-[12%] left-[12%] w-60 opacity-60">
      <WindowMock img="https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=80&w=600" alt="Diseño web para negocios con estadísticas" className="h-40" />
    </motion.div>
  </>
);